import { EmployeesModState } from './state';
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations} from "./mutations";


export const defaultState: EmployeesModState = {
    employees: [],
    employeeRoles: [],
};

export const employeesModule = {
    state: defaultState,
    mutations,
    actions,
    getters
};